<template>
  <div class="input-group">
    <select
      :value="filterOperator"
      class="form-select"
      style="max-width: 120px"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <select
      :id="computedFieldId"
      class="form-select"
      :value="displayValue"
      :disabled="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      @change="onFilterValueChange($event.target.value)"
    >
      <option value="">{{ placeholder || "Seleccione..." }}</option>
      <option
        v-for="icon in availableIcons"
        :key="icon"
        :value="icon"
      >
        {{ icon }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "FilterFieldIcon",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
    defaultIcons: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    availableIcons() {
      if (this.field.icons && Array.isArray(this.field.icons) && this.field.icons.length > 0) {
        return this.field.icons;
      }
      if (this.defaultIcons && Array.isArray(this.defaultIcons) && this.defaultIcons.length > 0) {
        return this.defaultIcons;
      }
      return [
        "home", "settings", "person", "group", "folder", "file", "image", "video",
        "music", "star", "favorite", "bookmark", "share", "download", "upload",
        "delete", "edit", "add", "remove", "check", "close", "arrow_back",
        "arrow_forward", "arrow_upward", "arrow_downward",
      ];
    },
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      return null;
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `filter-icon-${this.field.key}`;
    },
  },
  methods: {
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
}
</style>

